/* eslint-disable react/prop-types */
import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  makeStyles,
  Box,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import { setFilters, setCleanFilters } from "app/filters/duck/slices";
import _ from "lodash";
import NoResultsComponent from "app/common/NoResultsComponent";
import RecommendationFilterComponent from "./RecommendationFilterComponent";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  dialogTitleSmall: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    paddingLeft: "26px",
  },
  dialogContent: {
    width: "100%",
    height: "100%",
    padding: "20px",
    flexDirection: "column",
    display: "flex",
  },
  dialogContentSmall: {
    height: "100%",
    padding: "15px",
    flexDirection: "column",
    display: "flex",
  },
  dialogActions: {
    // marginBottom: "12px",
    // marginRight: "10.5%",
    borderTop: "1px solid #e2e2e2",
  },
  dialogRoot: {
    maxWidth: "475px",
  },
  actionsRecommendContainer: {
    flex: "display",
    flexDirection: "column",
  },
  dialogSubtitle: {
    marginBottom: "3px",
    paddingLeft: "5px",
  },
  dialogSubtitleSmall: {
    marginBottom: "3px",
  },
}));

const RecommendationDialogComponent = ({
  open = false,
  handleClose,
  actionsRecommend,
  isErrorGettingData,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [isbackgroundColorSelected, setIsBackgroundColorSelected] = useState(
    false
  );
  const catalogData = useSelector((state) => state.catalog);
  const areasData = useSelector((state) => state.areas);
  const retailersData = useSelector((state) => state.retailers);

  const handleCloseButton = () => {
    setSelectedFilter(null);
    setIsBackgroundColorSelected(false);
    handleClose();
  };

  const handleApplyFilter = () => {
    const differentFilters = [
      {
        id: "product",
        array: catalogData.products,
      },
      {
        id: "area",
        array: areasData,
      },
      {
        id: "retailer",
        array: retailersData,
      },
      {
        id: "line",
        array: catalogData.lines,
      },
      {
        id: "category",
        array: catalogData.categories,
      },
    ];
    if (selectedFilter !== null) {
      dispatch(setCleanFilters());
      // dispatch(setFilters({ area: undefined }));
      differentFilters.forEach((filter) => {
        if (
          selectedFilter[`${filter.id}_id`] !== null &&
          selectedFilter[`${filter.id}_label`] !== null
        ) {
          const findselectedFilter = _.find(filter.array, (item) => {
            return item.id === selectedFilter[`${filter.id}_id`];
          });
          const selectedFilterData = {};
          selectedFilterData[filter.id] = findselectedFilter;
          dispatch(setFilters(selectedFilterData));
        }
      });
      handleCloseButton();
    }
  };

  const typeError = isErrorGettingData ? (
    <NoResultsComponent customText="Error when getting recommended filters. Try again shortly" />
  ) : (
    <NoResultsComponent customText={actionsRecommend} />
  );
  return (
    <>
      <Dialog
        open={open}
        fullWidth
        onBackdropClick={() => handleCloseButton()}
        maxWidth="md"
        disableRestoreFocus
        classes={{
          paperWidthMd: classes.dialogRoot,
        }}
      >
        <DialogTitle
          className={
            isSmallScreen ? classes.dialogTitleSmall : classes.dialogTitle
          }
        >
          Recommendation Engine
        </DialogTitle>
        <DialogContent
          className={
            isSmallScreen ? classes.dialogContentSmall : classes.dialogContent
          }
        >
          {!isErrorGettingData &&
          actionsRecommend &&
          Array.isArray(actionsRecommend) ? (
            <>
              <Typography
                variant="subtitle1"
                className={
                  isSmallScreen
                    ? classes.dialogSubtitleSmall
                    : classes.dialogSubtitle
                }
              >
                Select one of the recommended filters
              </Typography>
              <Box
                id="selectLabel"
                className={classes.actionsRecommendContainer}
              >
                {_.map(actionsRecommend, (item, index) => {
                  return (
                    <RecommendationFilterComponent
                      filterData={item}
                      setSelectedFilter={setSelectedFilter}
                      recommendationFilterId={index}
                      setIsBackgroundColorSelected={
                        setIsBackgroundColorSelected
                      }
                      isbackgroundColorSelected={isbackgroundColorSelected}
                    />
                  );
                })}
              </Box>
            </>
          ) : (
            typeError
          )}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button autoFocus onClick={handleCloseButton}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleApplyFilter}
            color="primary"
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RecommendationDialogComponent;
